import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const RequireAuth = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-stone-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
};
